import React from 'react';

import { useDeleteCandidateFilter } from '../../common/useDeleteCandidateFilter';
import { MainTablePage } from '../../components/MainTablePage';
import { PageRoutesEnum } from '../../utils/routes';

import { CandidatesSearchForm } from './CandidatesSearchForm';
import { useCandidateTableColumnDefinitions } from './useCandidateTableColumnDefinitions';
import { useCandidateTableDataSource } from './useCandidateTableDataSource';
import { useGetCandidatesFilters } from './useGetCandidatesFilters';
import { useSaveCandidateFilter } from './useSaveCandidateFilter';
import { useSearchCandidates } from './useSearchCandidates';
import { useUpdateCandidateFilter } from './useUpdateCandidateFilter';

export const CandidatesPage = () => (
  <MainTablePage
    getFilters={useGetCandidatesFilters}
    saveFilter={useSaveCandidateFilter}
    updateFilter={useUpdateCandidateFilter}
    deleteFilter={useDeleteCandidateFilter}
    getColumnsDefinition={useCandidateTableColumnDefinitions}
    search={useSearchCandidates}
    getDataSource={useCandidateTableDataSource}
    storedFilterName="candidatesFilter"
    storedPagingData="candidatesPaging"
    title="Candidates"
    searchForm={CandidatesSearchForm}
    addPageRoute={PageRoutesEnum.candidateAdd}
    defaultFilter={{
      name: '',
      criteria: [],
      sort: [{ field: 'createdDate', order: 'DESC' }],
      isDefault: true,
      id: 0,
    }}
  />
);
